
import index from '~/pages/_uid.vue'
export default index
